/**
 * Feuille glissant depuis le bas — EF-NAV-001, EF-NAV-006.
 *
 * Une feuille n'est pas un écran : elle se superpose à l'écran courant, ne
 * change pas l'onglet actif et se referme sans destination. Elle se ferme par
 * le voile, par sa croix ou par l'exécution d'une de ses entrées.
 */

import type { ComponentChildren, JSX } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { Glyph } from '../icons';
import { ACTIONS } from '../labels';

export interface SheetProps {
  readonly title: string;
  readonly onClose: () => void;
  readonly children: ComponentChildren;
}

export function Sheet(props: SheetProps): JSX.Element {
  const panel = useRef<HTMLDivElement>(null);

  // Une feuille s'ouvre toujours dans son intégralité, sans défilement
  // préalable (EF-NAV-007).
  useEffect(() => {
    panel.current?.scrollTo?.(0, 0);
  }, []);

  return (
    <div
      class="sheet-backdrop"
      role="presentation"
      onClick={(event) => {
        if (event.target === event.currentTarget) props.onClose();
      }}
    >
      <div class="sheet" role="dialog" aria-modal="true" aria-label={props.title} ref={panel}>
        <div class="sheet__head">
          <h2>{props.title}</h2>
          <button type="button" class="icon-button" onClick={props.onClose}>
            <Glyph name="fermer" label={ACTIONS.close} />
          </button>
        </div>
        {props.children}
      </div>
    </div>
  );
}
